/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum IdentifierType {
  BROKER_ID = "BROKER_ID",
  BROKER_PATH = "BROKER_PATH",
  OFFICE_ID = "OFFICE_ID",
  OFFICE_URLTAG = "OFFICE_URLTAG",
}

export enum LeadType {
  CUSTOM = "CUSTOM",
  EPOST = "EPOST",
  FINANSIERING = "FINANSIERING",
  INTERESSENT = "INTERESSENT",
  KONTAKT = "KONTAKT",
  SOLDPRICE = "SOLDPRICE",
  VERDIVURDERING = "VERDIVURDERING",
}

export enum PageType {
  GENERELL = "GENERELL",
  KAMPANJE = "KAMPANJE",
  KONTOR = "KONTOR",
  MEGLER = "MEGLER",
  NORDEASELGEKJOPE = "NORDEASELGEKJOPE",
  OBJEKT = "OBJEKT",
  VISNINGSPAAMELDING = "VISNINGSPAAMELDING",
}

export enum PropertyAttachmentType {
  ds_vedlegg = "ds_vedlegg",
  vedlegg_salgsoppgave = "vedlegg_salgsoppgave",
}

export interface Consents {
  delmedutbygger?: boolean | null;
  budvarsel?: boolean | null;
  oppdateringer?: boolean | null;
  tipsomliknende?: boolean | null;
  generellmarkedsforing?: boolean | null;
  skalselgebolig?: boolean | null;
  finansiering?: boolean | null;
  forsikring?: boolean | null;
  kjop?: boolean | null;
  tipsomlignendeoggenerellmarkedsforing?: boolean | null;
}

export interface LeadInput {
  leadType: LeadType;
  pageType?: PageType | null;
  mailType?: number | null;
  identifierType?: IdentifierType | null;
  identifier?: string | null;
  diggerId?: string | null;
  wmId?: string | null;
  company?: string | null;
  name?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  address?: string | null;
  zip: string;
  email?: string | null;
  phone?: string | null;
  comment?: string | null;
  referer?: string | null;
  url?: string | null;
  consents?: Consents | null;
  listType?: string | null;
  notify?: LeadNotify | null;
  json?: any | null;
}

export interface LeadNotify {
  mail?: LeadNotifyMail | null;
  autoreply?: boolean | null;
}

export interface LeadNotifyMail {
  from: string;
  to: string;
  cc?: string | null;
  bcc?: string | null;
  subject: string;
}

export interface PropertyInput {
  sguid: string;
  attachmentType?: PropertyAttachmentType | null;
  preview?: boolean | null;
  includeInactive?: boolean | null;
  includeAccepted?: boolean | null;
  includeUnits?: boolean | null;
  includeArchived?: boolean | null;
  sold?: boolean | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
